module.exports = __webpack_public_path__ + "static/media/provider_redtiger.8a5e46d3.jpg";